// extracted by mini-css-extract-plugin
export default {"container":"CourseLayout_container__0hLSs","body":"CourseLayout_body__-rilB","main":"CourseLayout_main__AoTU2"};